import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { companyPaths } from "@/lib/offers";
import { scrollToId } from "@/lib/scroll";
import "@/App.css";

export default function SiteLayout() {
    const location = useLocation();
    const isCompany = companyPaths.includes(location.pathname);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        if (!location.hash) return;
        const timer = window.setTimeout(() => scrollToId(location.hash), 120);
        return () => window.clearTimeout(timer);
    }, [location.pathname, location.hash]);

    return (
        <div className={isCompany ? "App home-light" : "App grain"}>
            <Navbar />
            <Outlet />
            <Footer />
        </div>
    );
}
